export default "__VITE_ASSET__Cha_FaMJ__"